import Button from "@/components/Button"
import Icons from "@/components/Icon"
import { MissionListItemProps } from "@/components/MissionList/MissionItem"
import content from "@/components/MissionList/MissionItem/data.json"
import style from "@/components/MissionList/MissionItem/style.scss"
import { getKey } from "@/components/util"
import _ from "lodash"
import React from "react"
import MissionItemBody from "../../MissionItemBody"

const AwaitingUpload: React.SFC<Readonly<MissionListItemProps>> = (props) => {
  const body = getKey(content, "awaiting-upload")
  const Icon = getKey(Icons, body.icon)

  return (
    <>
      <div className={style.content}>
        <div className={style.description}>
          {Icon && <Icon className={style.icon} />}

          <MissionItemBody
            mission={props.mission}
            title={body.title}
            description={body.description
              .replace("%mission", `<strong>${props.mission.title}</strong>`)
              .replace("%size", `<strong>${props.mission.getSize()}</strong>`)}
          />
        </div>

        <div className={style.actions}>
          <Button
            label="Upload Mission"
            onClick={() => props.submitAllTaskData(props.mission)}
          />
        </div>
      </div>
    </>
  )
}

export default AwaitingUpload
